module.exports = __webpack_public_path__ + "img/ic_trending.cfc07b74.svg";